
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { computed, defineComponent, onMounted, ref, watchEffect } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import KtUserApproveModal from "@/views/pages/admin/users/UserApproveModal.vue";
import moment from "moment";
import AplicationTableAction from "@/components/table/ApplicationTableAction.vue";
import DropdownUsersFilter from "./DropdownUsersFilter.vue";

interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

export default defineComponent({
  name: "kt-widget-12",
  methods: {
    moment(date) {
      return moment(date).local().fromNow();
    },
  },
  components: {
    KtUserApproveModal,
    AplicationTableAction,
    DropdownUsersFilter,
  },
  props: {
    widgetClasses: String,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const tableColumns = ["user"];
    const tableCallFunction = Actions.GET_PENDING_USERS;

    console.log(route.query);

    const editUser = (user) => {
      document.getElementById("fakeModalId")?.click();
      store.commit(Mutations.SET_ADMIN_USER_EDIT, user);
    };

    const currentPendingUsers = computed(() => {
      return store.getters.currentPendingUsers != null &&
        store.getters.currentPendingUsers.data != null
        ? store.getters.currentPendingUsers.data
        : {};
    });

    return {
      currentPendingUsers,
      editUser,
      tableColumns,
      tableCallFunction,
    };
  },
});
